"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CofSyncMechanism = exports.FriendLink = exports.FriendData = exports.FideliusIdentity = exports.VerificationStatus_PhoneVerifyOptions = exports.VerificationStatus_PhoneVerifyOptionsMapEntry = exports.VerificationStatus = exports.DeviceTokenResponse = exports.SecurityData = exports.TOSAcceptance = exports.UserState = exports.UserSession = exports.BootstrapData = exports.CofSyncMechanism_TriggerType = exports.FriendLink_ConnectionType = exports.VerificationStatus_VerificationMethod = exports.VerificationStatus_PhoneVerifyOption = exports.SecurityData_AccountSafetyAction = void 0;
/* eslint-disable */
const timestamp_1 = require("../../google/protobuf/timestamp");
const long_1 = __importDefault(require("long"));
const network_tokens_1 = require("../../auth/snaptoken/network_tokens");
const uuid_1 = require("../../core/uuid");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** actions that the client should take for the compromised account */
var SecurityData_AccountSafetyAction;
(function (SecurityData_AccountSafetyAction) {
    /** ACCOUNT_SAFETY_ACTION_UNSET - default */
    SecurityData_AccountSafetyAction[SecurityData_AccountSafetyAction["ACCOUNT_SAFETY_ACTION_UNSET"] = 0] = "ACCOUNT_SAFETY_ACTION_UNSET";
    /** ACCOUNT_SAFETY_ACTION_CHANGE_PASSWORD_TAKEOVER - show a "Compromised Password" modal */
    SecurityData_AccountSafetyAction[SecurityData_AccountSafetyAction["ACCOUNT_SAFETY_ACTION_CHANGE_PASSWORD_TAKEOVER"] = 1] = "ACCOUNT_SAFETY_ACTION_CHANGE_PASSWORD_TAKEOVER";
    SecurityData_AccountSafetyAction[SecurityData_AccountSafetyAction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SecurityData_AccountSafetyAction = exports.SecurityData_AccountSafetyAction || (exports.SecurityData_AccountSafetyAction = {}));
/**
 * Phone Verify Option
 * options here should be a subset of valid telephony delivery strategy. Refer to the following link for the full list of delivery strategy
 * https://github.sc-corp.net/Snapchat/pb_schema/blob/7652bba104e9ed70a7c77b5db68eb40a2e8032c8/proto/seraph/seraph.proto#L285
 */
var VerificationStatus_PhoneVerifyOption;
(function (VerificationStatus_PhoneVerifyOption) {
    /** OPTION_UNSET - default value */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["OPTION_UNSET"] = 0] = "OPTION_UNSET";
    /** SMS - SMS message */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["SMS"] = 1] = "SMS";
    /** VOICE - Voice verification */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["VOICE"] = 2] = "VOICE";
    /** FLASH - Flash call verification */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["FLASH"] = 3] = "FLASH";
    /** DATA_VERIFICATION - Data Verification/Silent Mobile Verification/seamless verification */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["DATA_VERIFICATION"] = 4] = "DATA_VERIFICATION";
    /** WHATSAPP - whatsapp */
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["WHATSAPP"] = 5] = "WHATSAPP";
    VerificationStatus_PhoneVerifyOption[VerificationStatus_PhoneVerifyOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VerificationStatus_PhoneVerifyOption = exports.VerificationStatus_PhoneVerifyOption || (exports.VerificationStatus_PhoneVerifyOption = {}));
/** Verification methods */
var VerificationStatus_VerificationMethod;
(function (VerificationStatus_VerificationMethod) {
    /** UNSET - default value */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["UNSET"] = 0] = "UNSET";
    /**
     * PHONE_FIRST_EMAIL_BYPASSED - The phone option is shown first.  If a phone is provided, the email option is automatically skipped.
     * The user can switch between phone and email
     */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["PHONE_FIRST_EMAIL_BYPASSED"] = 1] = "PHONE_FIRST_EMAIL_BYPASSED";
    /**
     * PHONE_FIRST_EMAIL_SKIPPABLE - The phone option is shown first.  If a phone is provided, the email option is shown but the user can manually skip it.
     * The user can switch between phone and email
     */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["PHONE_FIRST_EMAIL_SKIPPABLE"] = 2] = "PHONE_FIRST_EMAIL_SKIPPABLE";
    /**
     * EMAIL_FIRST_PHONE_BYPASSED - The email option is shown first.  If an email is provided, the phone option is automatically skipped.
     * The user can switch between email and phone
     */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["EMAIL_FIRST_PHONE_BYPASSED"] = 3] = "EMAIL_FIRST_PHONE_BYPASSED";
    /**
     * EMAIL_FIRST_PHONE_SKIPPABLE - The email option is shown first.  If an email is provided, the phone option is shown but the user can manually skip it.
     * The user can switch between email and phone
     */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["EMAIL_FIRST_PHONE_SKIPPABLE"] = 4] = "EMAIL_FIRST_PHONE_SKIPPABLE";
    /** EMAIL_ONLY - The email option is shown, with no option to switch to phone. */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["EMAIL_ONLY"] = 5] = "EMAIL_ONLY";
    /** PHONE_ONLY - The phone option is shown, with no option to switch to email. */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["PHONE_ONLY"] = 6] = "PHONE_ONLY";
    /** PHONE_SKIPPABLE_ONLY - The phone option is shown, and the user has the option to manually skip it.  Added for Google Sign Up */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["PHONE_SKIPPABLE_ONLY"] = 7] = "PHONE_SKIPPABLE_ONLY";
    /** EMAIL_AND_PHONE_BYPASSED - Both the email and phone options are automatically skipped.  Added for Google Sign Up */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["EMAIL_AND_PHONE_BYPASSED"] = 8] = "EMAIL_AND_PHONE_BYPASSED";
    /** EMAIL_SKIPPABLE_ONLY - The email option is shown, and the user has the option to manually skip it. */
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["EMAIL_SKIPPABLE_ONLY"] = 9] = "EMAIL_SKIPPABLE_ONLY";
    VerificationStatus_VerificationMethod[VerificationStatus_VerificationMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VerificationStatus_VerificationMethod = exports.VerificationStatus_VerificationMethod || (exports.VerificationStatus_VerificationMethod = {}));
/**
 * Type of connection
 * Copied from Atlas Friend Service proto
 */
var FriendLink_ConnectionType;
(function (FriendLink_ConnectionType) {
    /** UNKNOWN_UNSET - Default state - should not be used */
    FriendLink_ConnectionType[FriendLink_ConnectionType["UNKNOWN_UNSET"] = 0] = "UNKNOWN_UNSET";
    /** FRIEND - Source user and destination user are friends (friend request accepted) */
    FriendLink_ConnectionType[FriendLink_ConnectionType["FRIEND"] = 1] = "FRIEND";
    /** PENDING - Destination user has UserData.snap_privacy = FRIENDS, friend request has not yet been accepted */
    FriendLink_ConnectionType[FriendLink_ConnectionType["PENDING"] = 2] = "PENDING";
    /** FOLLOWING - Destination user has UserData.snap_privacy = EVERYONE, friend request has not yet been accepted */
    FriendLink_ConnectionType[FriendLink_ConnectionType["FOLLOWING"] = 3] = "FOLLOWING";
    /** BLOCKED - Identifies that a source user blocked destination user */
    FriendLink_ConnectionType[FriendLink_ConnectionType["BLOCKED"] = 4] = "BLOCKED";
    /**
     * DELETED - Identifies one of the two cases:
     *   (a) A source user deleted destination user from friends
     *   (b) A destination user blocked source user.
     */
    FriendLink_ConnectionType[FriendLink_ConnectionType["DELETED"] = 5] = "DELETED";
    FriendLink_ConnectionType[FriendLink_ConnectionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FriendLink_ConnectionType = exports.FriendLink_ConnectionType || (exports.FriendLink_ConnectionType = {}));
/** buf:lint:ignore COMMENT_ENUM */
var CofSyncMechanism_TriggerType;
(function (CofSyncMechanism_TriggerType) {
    /** UNSET - Default state - should not be used */
    CofSyncMechanism_TriggerType[CofSyncMechanism_TriggerType["UNSET"] = 0] = "UNSET";
    /** REGISTER_PASSWORD_PAGE_SUCCESS - initiate a COF sync immediately after processing response from the registration password page */
    CofSyncMechanism_TriggerType[CofSyncMechanism_TriggerType["REGISTER_PASSWORD_PAGE_SUCCESS"] = 1] = "REGISTER_PASSWORD_PAGE_SUCCESS";
    CofSyncMechanism_TriggerType[CofSyncMechanism_TriggerType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CofSyncMechanism_TriggerType = exports.CofSyncMechanism_TriggerType || (exports.CofSyncMechanism_TriggerType = {}));
function createBaseBootstrapData() {
    return {
        userSession: undefined,
        coreUserData: new Uint8Array(),
        sup: new Uint8Array(),
        cof: new Uint8Array(),
        fideliusIdentity: undefined,
        userState: undefined,
        securityData: undefined,
        friendData: undefined,
        cofSyncMechanism: undefined,
    };
}
exports.BootstrapData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userSession !== undefined) {
            exports.UserSession.encode(message.userSession, writer.uint32(10).fork()).ldelim();
        }
        if (message.coreUserData.length !== 0) {
            writer.uint32(18).bytes(message.coreUserData);
        }
        if (message.sup.length !== 0) {
            writer.uint32(26).bytes(message.sup);
        }
        if (message.cof.length !== 0) {
            writer.uint32(34).bytes(message.cof);
        }
        if (message.fideliusIdentity !== undefined) {
            exports.FideliusIdentity.encode(message.fideliusIdentity, writer.uint32(42).fork()).ldelim();
        }
        if (message.userState !== undefined) {
            exports.UserState.encode(message.userState, writer.uint32(50).fork()).ldelim();
        }
        if (message.securityData !== undefined) {
            exports.SecurityData.encode(message.securityData, writer.uint32(58).fork()).ldelim();
        }
        if (message.friendData !== undefined) {
            exports.FriendData.encode(message.friendData, writer.uint32(66).fork()).ldelim();
        }
        if (message.cofSyncMechanism !== undefined) {
            exports.CofSyncMechanism.encode(message.cofSyncMechanism, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBootstrapData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userSession = exports.UserSession.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.coreUserData = reader.bytes();
                    break;
                case 3:
                    message.sup = reader.bytes();
                    break;
                case 4:
                    message.cof = reader.bytes();
                    break;
                case 5:
                    message.fideliusIdentity = exports.FideliusIdentity.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.userState = exports.UserState.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.securityData = exports.SecurityData.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.friendData = exports.FriendData.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.cofSyncMechanism = exports.CofSyncMechanism.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseBootstrapData();
        message.userSession =
            object.userSession !== undefined && object.userSession !== null
                ? exports.UserSession.fromPartial(object.userSession)
                : undefined;
        message.coreUserData = object.coreUserData ?? new Uint8Array();
        message.sup = object.sup ?? new Uint8Array();
        message.cof = object.cof ?? new Uint8Array();
        message.fideliusIdentity =
            object.fideliusIdentity !== undefined && object.fideliusIdentity !== null
                ? exports.FideliusIdentity.fromPartial(object.fideliusIdentity)
                : undefined;
        message.userState =
            object.userState !== undefined && object.userState !== null
                ? exports.UserState.fromPartial(object.userState)
                : undefined;
        message.securityData =
            object.securityData !== undefined && object.securityData !== null
                ? exports.SecurityData.fromPartial(object.securityData)
                : undefined;
        message.friendData =
            object.friendData !== undefined && object.friendData !== null
                ? exports.FriendData.fromPartial(object.friendData)
                : undefined;
        message.cofSyncMechanism =
            object.cofSyncMechanism !== undefined && object.cofSyncMechanism !== null
                ? exports.CofSyncMechanism.fromPartial(object.cofSyncMechanism)
                : undefined;
        return message;
    },
};
function createBaseUserSession() {
    return {
        userId: "",
        mutableUsername: "",
        snapadsId: "",
        lagunaId: "",
        authToken: "",
        snapSessionResponse: undefined,
    };
}
exports.UserSession = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.mutableUsername !== "") {
            writer.uint32(18).string(message.mutableUsername);
        }
        if (message.snapadsId !== "") {
            writer.uint32(26).string(message.snapadsId);
        }
        if (message.lagunaId !== "") {
            writer.uint32(34).string(message.lagunaId);
        }
        if (message.authToken !== "") {
            writer.uint32(42).string(message.authToken);
        }
        if (message.snapSessionResponse !== undefined) {
            network_tokens_1.SnapSessionResponse.encode(message.snapSessionResponse, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId = reader.string();
                    break;
                case 2:
                    message.mutableUsername = reader.string();
                    break;
                case 3:
                    message.snapadsId = reader.string();
                    break;
                case 4:
                    message.lagunaId = reader.string();
                    break;
                case 5:
                    message.authToken = reader.string();
                    break;
                case 6:
                    message.snapSessionResponse = network_tokens_1.SnapSessionResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUserSession();
        message.userId = object.userId ?? "";
        message.mutableUsername = object.mutableUsername ?? "";
        message.snapadsId = object.snapadsId ?? "";
        message.lagunaId = object.lagunaId ?? "";
        message.authToken = object.authToken ?? "";
        message.snapSessionResponse =
            object.snapSessionResponse !== undefined &&
                object.snapSessionResponse !== null
                ? network_tokens_1.SnapSessionResponse.fromPartial(object.snapSessionResponse)
                : undefined;
        return message;
    },
};
function createBaseUserState() {
    return {
        verificationStatus: undefined,
        tosAcceptance: undefined,
        previousActiveTimestamp: undefined,
    };
}
exports.UserState = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.verificationStatus !== undefined) {
            exports.VerificationStatus.encode(message.verificationStatus, writer.uint32(10).fork()).ldelim();
        }
        if (message.tosAcceptance !== undefined) {
            exports.TOSAcceptance.encode(message.tosAcceptance, writer.uint32(18).fork()).ldelim();
        }
        if (message.previousActiveTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.previousActiveTimestamp), writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.verificationStatus = exports.VerificationStatus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.tosAcceptance = exports.TOSAcceptance.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.previousActiveTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUserState();
        message.verificationStatus =
            object.verificationStatus !== undefined &&
                object.verificationStatus !== null
                ? exports.VerificationStatus.fromPartial(object.verificationStatus)
                : undefined;
        message.tosAcceptance =
            object.tosAcceptance !== undefined && object.tosAcceptance !== null
                ? exports.TOSAcceptance.fromPartial(object.tosAcceptance)
                : undefined;
        message.previousActiveTimestamp =
            object.previousActiveTimestamp ?? undefined;
        return message;
    },
};
function createBaseTOSAcceptance() {
    return {
        tos9: false,
        tos9And10: false,
        tos10: false,
        tos9And11: false,
        tos11: false,
        tos12: false,
        tos13: false,
        tos14: false,
    };
}
exports.TOSAcceptance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tos9 === true) {
            writer.uint32(8).bool(message.tos9);
        }
        if (message.tos9And10 === true) {
            writer.uint32(16).bool(message.tos9And10);
        }
        if (message.tos10 === true) {
            writer.uint32(24).bool(message.tos10);
        }
        if (message.tos9And11 === true) {
            writer.uint32(32).bool(message.tos9And11);
        }
        if (message.tos11 === true) {
            writer.uint32(40).bool(message.tos11);
        }
        if (message.tos12 === true) {
            writer.uint32(48).bool(message.tos12);
        }
        if (message.tos13 === true) {
            writer.uint32(56).bool(message.tos13);
        }
        if (message.tos14 === true) {
            writer.uint32(64).bool(message.tos14);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTOSAcceptance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tos9 = reader.bool();
                    break;
                case 2:
                    message.tos9And10 = reader.bool();
                    break;
                case 3:
                    message.tos10 = reader.bool();
                    break;
                case 4:
                    message.tos9And11 = reader.bool();
                    break;
                case 5:
                    message.tos11 = reader.bool();
                    break;
                case 6:
                    message.tos12 = reader.bool();
                    break;
                case 7:
                    message.tos13 = reader.bool();
                    break;
                case 8:
                    message.tos14 = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTOSAcceptance();
        message.tos9 = object.tos9 ?? false;
        message.tos9And10 = object.tos9And10 ?? false;
        message.tos10 = object.tos10 ?? false;
        message.tos9And11 = object.tos9And11 ?? false;
        message.tos11 = object.tos11 ?? false;
        message.tos12 = object.tos12 ?? false;
        message.tos13 = object.tos13 ?? false;
        message.tos14 = object.tos14 ?? false;
        return message;
    },
};
function createBaseSecurityData() {
    return {
        deviceToken: undefined,
        twoFaSmsEnabled: false,
        twoFaOtpEnabled: false,
        accountSafetyAction: 0,
    };
}
exports.SecurityData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deviceToken !== undefined) {
            exports.DeviceTokenResponse.encode(message.deviceToken, writer.uint32(10).fork()).ldelim();
        }
        if (message.twoFaSmsEnabled === true) {
            writer.uint32(16).bool(message.twoFaSmsEnabled);
        }
        if (message.twoFaOtpEnabled === true) {
            writer.uint32(24).bool(message.twoFaOtpEnabled);
        }
        if (message.accountSafetyAction !== 0) {
            writer.uint32(32).int32(message.accountSafetyAction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSecurityData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deviceToken = exports.DeviceTokenResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.twoFaSmsEnabled = reader.bool();
                    break;
                case 3:
                    message.twoFaOtpEnabled = reader.bool();
                    break;
                case 4:
                    message.accountSafetyAction = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSecurityData();
        message.deviceToken =
            object.deviceToken !== undefined && object.deviceToken !== null
                ? exports.DeviceTokenResponse.fromPartial(object.deviceToken)
                : undefined;
        message.twoFaSmsEnabled = object.twoFaSmsEnabled ?? false;
        message.twoFaOtpEnabled = object.twoFaOtpEnabled ?? false;
        message.accountSafetyAction = object.accountSafetyAction ?? 0;
        return message;
    },
};
function createBaseDeviceTokenResponse() {
    return { id: "", value: "" };
}
exports.DeviceTokenResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeviceTokenResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDeviceTokenResponse();
        message.id = object.id ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseVerificationStatus() {
    return {
        registrationVerified: false,
        preferredVerificationMethod: 0,
        phoneVerifyOptionsMap: {},
    };
}
exports.VerificationStatus = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.registrationVerified === true) {
            writer.uint32(8).bool(message.registrationVerified);
        }
        if (message.preferredVerificationMethod !== 0) {
            writer.uint32(16).int32(message.preferredVerificationMethod);
        }
        Object.entries(message.phoneVerifyOptionsMap).forEach(([key, value]) => {
            exports.VerificationStatus_PhoneVerifyOptionsMapEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVerificationStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.registrationVerified = reader.bool();
                    break;
                case 2:
                    message.preferredVerificationMethod = reader.int32();
                    break;
                case 3:
                    const entry3 = exports.VerificationStatus_PhoneVerifyOptionsMapEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.phoneVerifyOptionsMap[entry3.key] = entry3.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseVerificationStatus();
        message.registrationVerified = object.registrationVerified ?? false;
        message.preferredVerificationMethod =
            object.preferredVerificationMethod ?? 0;
        message.phoneVerifyOptionsMap = Object.entries(object.phoneVerifyOptionsMap ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.VerificationStatus_PhoneVerifyOptions.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseVerificationStatus_PhoneVerifyOptionsMapEntry() {
    return { key: "", value: undefined };
}
exports.VerificationStatus_PhoneVerifyOptionsMapEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.VerificationStatus_PhoneVerifyOptions.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVerificationStatus_PhoneVerifyOptionsMapEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = exports.VerificationStatus_PhoneVerifyOptions.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseVerificationStatus_PhoneVerifyOptionsMapEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.VerificationStatus_PhoneVerifyOptions.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseVerificationStatus_PhoneVerifyOptions() {
    return { options: [] };
}
exports.VerificationStatus_PhoneVerifyOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.options) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVerificationStatus_PhoneVerifyOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.options.push(reader.int32());
                        }
                    }
                    else {
                        message.options.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseVerificationStatus_PhoneVerifyOptions();
        message.options = object.options?.map((e) => e) || [];
        return message;
    },
};
function createBaseFideliusIdentity() {
    return { iwek: new Uint8Array(), hashedPublicKey: new Uint8Array() };
}
exports.FideliusIdentity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.iwek.length !== 0) {
            writer.uint32(10).bytes(message.iwek);
        }
        if (message.hashedPublicKey.length !== 0) {
            writer.uint32(18).bytes(message.hashedPublicKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFideliusIdentity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.iwek = reader.bytes();
                    break;
                case 2:
                    message.hashedPublicKey = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFideliusIdentity();
        message.iwek = object.iwek ?? new Uint8Array();
        message.hashedPublicKey = object.hashedPublicKey ?? new Uint8Array();
        return message;
    },
};
function createBaseFriendData() {
    return { friendLinks: [], bestFriends: [] };
}
exports.FriendData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.friendLinks) {
            exports.FriendLink.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.bestFriends) {
            uuid_1.UUID.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFriendData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.friendLinks.push(exports.FriendLink.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.bestFriends.push(uuid_1.UUID.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFriendData();
        message.friendLinks =
            object.friendLinks?.map((e) => exports.FriendLink.fromPartial(e)) || [];
        message.bestFriends =
            object.bestFriends?.map((e) => uuid_1.UUID.fromPartial(e)) || [];
        return message;
    },
};
function createBaseFriendLink() {
    return {
        mutableUsername: "",
        userId: undefined,
        connectionType: 0,
        displayName: "",
        addedTs: "0",
        reverseAddedTs: "0",
        muted: false,
        legacyUsername: "",
    };
}
exports.FriendLink = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.mutableUsername !== "") {
            writer.uint32(10).string(message.mutableUsername);
        }
        if (message.userId !== undefined) {
            uuid_1.UUID.encode(message.userId, writer.uint32(18).fork()).ldelim();
        }
        if (message.connectionType !== 0) {
            writer.uint32(24).int32(message.connectionType);
        }
        if (message.displayName !== "") {
            writer.uint32(34).string(message.displayName);
        }
        if (message.addedTs !== "0") {
            writer.uint32(40).uint64(message.addedTs);
        }
        if (message.reverseAddedTs !== "0") {
            writer.uint32(48).uint64(message.reverseAddedTs);
        }
        if (message.muted === true) {
            writer.uint32(56).bool(message.muted);
        }
        if (message.legacyUsername !== "") {
            writer.uint32(66).string(message.legacyUsername);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFriendLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mutableUsername = reader.string();
                    break;
                case 2:
                    message.userId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.connectionType = reader.int32();
                    break;
                case 4:
                    message.displayName = reader.string();
                    break;
                case 5:
                    message.addedTs = longToString(reader.uint64());
                    break;
                case 6:
                    message.reverseAddedTs = longToString(reader.uint64());
                    break;
                case 7:
                    message.muted = reader.bool();
                    break;
                case 8:
                    message.legacyUsername = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFriendLink();
        message.mutableUsername = object.mutableUsername ?? "";
        message.userId =
            object.userId !== undefined && object.userId !== null
                ? uuid_1.UUID.fromPartial(object.userId)
                : undefined;
        message.connectionType = object.connectionType ?? 0;
        message.displayName = object.displayName ?? "";
        message.addedTs = object.addedTs ?? "0";
        message.reverseAddedTs = object.reverseAddedTs ?? "0";
        message.muted = object.muted ?? false;
        message.legacyUsername = object.legacyUsername ?? "";
        return message;
    },
};
function createBaseCofSyncMechanism() {
    return { triggerType: 0 };
}
exports.CofSyncMechanism = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.triggerType !== 0) {
            writer.uint32(8).int32(message.triggerType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCofSyncMechanism();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.triggerType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCofSyncMechanism();
        message.triggerType = object.triggerType ?? 0;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000).toString();
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = Number(t.seconds) * 1_000;
    millis += t.nanos / 1_000_000;
    return new Date(millis);
}
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=login_bootstrap.js.map